
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/pdf-tools/extract-pdf-pages",
      function () {
        return require("private-next-pages/signature/pdf-tools/extract-pdf-pages/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signature/pdf-tools/extract-pdf-pages"])
      });
    }
  